var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{attrs:{"inline":true},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-fields"},_vm._l((_vm.formFields),function(field){return _c('el-form-item',{key:field.key,attrs:{"label":_vm.getFieldLabel(field)}},[_c(_vm.renderField(field),{tag:"component"})],1)}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }